import { getFromLocalStorage, setToLocalStorage } from '../../common/dom-helpers'
import { LocalStorageKeys } from '../../environments'
import { getFeatureFlagValue } from '../feature-flags'
import { FeatureFlagsVariations } from '../feature-flags/models'
import type { Theme } from '../shell-namespace'
import { emitThemeChanged } from '../shell-namespace'

export const DEFAULT_THEME: Theme = 'light'

export function setChameleonTheme(theme: Theme) {
  const currentTheme = getChameleonTheme()
  if (currentTheme !== theme) {
    setChameleonThemeInLocalStorage(theme)
    emitThemeChanged(theme)
  }
}

export function updateChameleonThemeProvider(themeProvider: Element, theme: Theme) {
  if (theme === 'system') {
    themeProvider.setAttribute('automatic', 'true')
    themeProvider.removeAttribute('theme')
  } else {
    themeProvider.setAttribute('theme', theme)
    themeProvider.removeAttribute('automatic')
  }
}

export function setChameleonThemeInLocalStorage(theme: Theme) {
  setToLocalStorage(LocalStorageKeys.chameleonTheme, theme)
}

export function getChameleonTheme(): Theme {
  let theme = getFeatureFlagValue(FeatureFlagsVariations.SHELL_ENABLE_DARKMODE)
    ? (getFromLocalStorage(LocalStorageKeys.chameleonTheme) as Theme | null)
    : DEFAULT_THEME

  if (!theme) {
    theme = DEFAULT_THEME
  }
  return theme
}
